import React from 'react'

const About = () => {
  return (
    <div name='about' id='about' className='w-full min-h-screen  text-white bg-gradient-to-b from-gray-800 to-black flex flex-col justify-center'>
      <div className='flex flex-col justify-center h-full max-w-screen-lg p-4 pb-8 mx-auto '>







        <div >
          <p className='inline text-4xl font-bold border-b-4 border-gray-500'>
            About
          </p>
        </div>

        <p className='mt-10 text-xl '>
          As a dedicated computer science engineering student, my passion lies in unraveling the intricacies of technology and mastering complex concepts. With a commitment to continuous learning, I strive to break down technical subjects into simpler components, ensuring a thorough and clear understanding.




        </p>

        <br />

        <p className='text-xl'>
          My enthusiasm for delving into various domains within computer science, including algorithms, data structures, artificial intelligence, and software development, reflects my eagerness to explore and excel in diverse areas. I am driven by a goal to simplify complex technical concepts, making them accessible and fostering a deeper connection with the material.
        </p>

        <br></br>
        <p className='text-xl'>
          In addition to my academic pursuits, I actively seek opportunities to apply my knowledge in real-world scenarios. Through projects and hands-on experiences, I aim to not only enhance my skills but also contribute meaningfully to the field.
        </p>
        <br></br>
        <p className='text-xl'>
          As a prospective candidate, I bring a strong foundation in computer science, a passion for innovation, and a dedication to continuous improvement. I am excited about the possibility of contributing to a dynamic team and making a positive impact in the ever-evolving landscape of technology.
        </p>

      </div>
    </div>
  )
}

export default About